import { render } from "./TasksLogin.vue?vue&type=template&id=363e983a"
import script from "./TasksLogin.vue?vue&type=script&lang=js"
export * from "./TasksLogin.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Build Apps\\bestphone\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__